const backendPt = {
  auth_not_authenticated: 'Faça login para continuar.',
  auth_permission_denied_add_org: 'Você não tem permissão para adicionar uma organização.',
  payload_missing_required_fields: 'Algumas informações obrigatórias estão faltando.',
  organisation_invalid_type: 'O tipo de organização não é válido.',
  organisation_duplicate_owner_name: 'Já existe uma organização com esse nome.',
  organisation_create_failed: 'Não foi possível criar a organização.',
  organisation_set_claims_failed_owner: 'Não foi possível atualizar as permissões do proprietário.',
  organisation_set_claims_failed_user: 'Não foi possível atualizar as permissões do usuário.',
  organisation_add_failed: 'Não foi possível adicionar a organização.',
  organisation_not_found: 'Não foi possível encontrar essa organização.',
  organisation_missing_fields: 'Faltam informações obrigatórias na organização.',
  onboarding_not_new_user: 'Esta conta já concluiu a integração.',
  onboarding_unknown_error: 'Ocorreu um erro ao finalizar a integração.',
  email_invalid_argument: 'Digite um endereço de e-mail válido.',
  email_already_verified: 'Este e-mail já está verificado.',
  email_no_data: 'Não foi possível preparar o e-mail de verificação.',
  email_sending_failed: 'Não foi possível enviar o e-mail. Tente novamente mais tarde.',
  email_verification_failed: 'Não foi possível enviar um novo e-mail de verificação.',
  promoter_not_found: 'Não foi possível encontrar esse promotor.',
  promoter_missing_claims: 'O perfil do promotor está incompleto.',
  password_strength_failed: 'Escolha uma senha mais forte que atenda a todos os requisitos.',
  invitation_invalid_token: 'Seu link de convite é inválido ou expirou. Abra o e-mail de convite mais recente.',
  invitation_not_found: 'Não foi possível encontrar esse convite.',
  invitation_not_pending: 'Este convite não está mais pendente.',
  invitation_missing_id: 'A referência do convite está faltando.',
  invitation_public_cancel_denied: 'Convites públicos não podem ser cancelados.',
  invitation_not_inviter: 'Somente quem convidou pode gerenciar este convite.',
  invitation_not_inviter_or_delegate: 'Somente quem convidou ou seu delegado pode gerenciar este convite.',
  invitation_promoter_not_public: 'Este promotor não aceita convites públicos.',
  invitation_invalid_email_format: 'Informe um e-mail e uma senha válidos.',
  invitation_invalid_role_division: 'O papel ou divisão escolhido não é permitido.',
  invitation_already_accepted: 'Essa pessoa já aceitou um convite.',
  invitation_email_in_use: 'Este e-mail já está cadastrado.',
  invitation_create_failed: 'Não foi possível criar o convite.',
  invitation_create_user_failed: 'Não foi possível criar a conta do usuário.',
  invitation_create_user_ref_failed: 'Não foi possível vincular a conta do usuário.',
  invitation_inviter_data_failed: 'Não foi possível carregar os dados de quem convidou.',
  invitation_inviter_claims_failed: 'Não foi possível carregar as permissões de quem convidou.',
  invitation_custom_claims_too_large: 'As permissões do convite são extensas demais.',
  invitation_invite_permission_denied: 'Você não tem permissão para convidar alguém.',
  invitation_fetch_failed: 'Não foi possível carregar os convites.',
  invitation_user_missing_email: 'Sua conta precisa de um endereço de e-mail.',
  invitation_owner_missing: 'Não foi possível encontrar o proprietário do promotor.',
  invitation_role_not_authorized: 'Este papel não está autorizado para convites.',
  invitation_role_not_found: 'Não foi possível encontrar esse papel.',
  invitation_pending_exists: 'Já existe um convite em andamento para essa pessoa.',
  invitation_cancel_unknown: 'Não foi possível cancelar o convite.',
  invitation_reject_unknown: 'Não foi possível recusar o convite.',
  invitation_request_unknown: 'Não foi possível enviar a solicitação de convite.',
  verify_email_unknown: 'Não foi possível verificar o e-mail.',
  superuser_unauthorized: 'Somente superusuários podem realizar esta ação.',
  superuser_invitations_unknown: 'Não foi possível carregar a lista de convites.',
  superuser_users_unknown: 'Não foi possível carregar a lista de usuários.',
  superuser_organisations_unknown: 'Não foi possível carregar a lista de organizações.',
  signup_requires_auth: 'Faça login para continuar.',
  signup_unknown_error: 'Ocorreu um erro ao criar a conta.',
  signup_update_password_failed: 'Não foi possível atualizar a senha.',
  provider_already_exists: 'Este provedor já existe.',
  custom_claims_set_failed: 'Não foi possível atualizar as permissões da conta.',
} as const;

export default backendPt;
